import script from "./FundraisingCollateral.vue?vue&type=script&setup=true&lang=js"
export * from "./FundraisingCollateral.vue?vue&type=script&setup=true&lang=js"

import "./FundraisingCollateral.vue?vue&type=style&index=0&id=241c0418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241c0418"]])

export default __exports__